/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurant`
};

const en_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurant`
};

const es_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurante`
};

const fr_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurant`
};

const it_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Ristorante`
};

const nl_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurant`
};

const pt_reststopservice__restaurant2 = /** @type {(inputs: {}) => string} */ () => {
	return `Restaurante`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const reststopservice__restaurant2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.reststopservice__restaurant2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("reststopservice__restaurant2", locale)
	if (locale === "de") return de_reststopservice__restaurant2(inputs)
	if (locale === "en") return en_reststopservice__restaurant2(inputs)
	if (locale === "es") return es_reststopservice__restaurant2(inputs)
	if (locale === "fr") return fr_reststopservice__restaurant2(inputs)
	if (locale === "it") return it_reststopservice__restaurant2(inputs)
	if (locale === "nl") return nl_reststopservice__restaurant2(inputs)
	return pt_reststopservice__restaurant2(inputs)
};
export { reststopservice__restaurant2 as "restStopService__restaurant" }